import { pageUrl } from '../data/pageMeta.js';

export function breadcrumbJsonLd(crumbs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: crumb.name,
      item: pageUrl(crumb.path)
    }))
  };
}

export function setBreadcrumbJsonLd(crumbs) {
  const existing = document.getElementById('breadcrumb-json-ld');
  if (!crumbs?.length) {
    existing?.remove();
    return;
  }

  const script = existing || document.createElement('script');
  script.id = 'breadcrumb-json-ld';
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(breadcrumbJsonLd(crumbs));
  if (!existing) document.head.appendChild(script);
}
